/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Exe

document.addEventListener("DOMContentLoaded", function () {
    rtAPI.init();
});

//#endregion

//#region Vars

rtAPI.query = {};

//#endregion

//#region Init

rtAPI.init = function () {
    rtAPI.query.string = window.location.search.substring(1);
    rtAPI.query.params = new URLSearchParams(window.location.search); //The URLSearchParams API offers: has(), get() and getAll()
}

rtAPI.initElement = function (section, value, sid, className, requiredGroup) {
    var targetId = eval(`rtAPI.${section}.${value}`);
    if (targetId == false) return;
    if (!rtAPI.isString(targetId)) return;
    var targetElement = document.getElementById(targetId);
    if (!rtAPI.isValidElement(targetElement)) {
        this.sysError.write('Init', `Missing Element in rtAPI.${section}. ${value} is missing on this page`, `Looking for ${targetId}`);
        console.log(`Init - Missing Element in rtAPI.${section}. ${value} is missing on this page. Looking for ${targetId}`)
    }
    eval(`rtAPI.${section}.${value} = targetElement`);
    if (sid != undefined) targetElement.setAttribute("sid-key", sid);
    if (className != null && className != undefined && (!targetElement.className || targetElement.className == '')) targetElement.className = className;
    rtAPI.markInputRequired(targetElement, requiredGroup, value);
}

//#endregion

//#region Is

rtAPI.isNothing = function (element) {
    if (element == undefined) return true;
    if (element == null) return true;
    return false;
}
rtAPI.isValidElement = function (element) {
    if (rtAPI.isNothing(element)) return false;
    if (rtAPI.isString(element)) return false;
    if (element == false) return true;
    return true;
}

rtAPI.isString = function (element) {
    if (typeof element === 'string') return true;
    if (element instanceof String) return true;
    return false;
}

//#endregion

//#region Misc

rtAPI.clickElement = function (element, event) {
    if (!rtAPI.isValidElement(element)) {
        this.sysError.write('Add Click', `Missing Element on this page`, `Looking for ${element.id}`);
        console.log(`Add Click - Missing Element on this page. Looking for ${element.id}`)
        return;
    }
    element.addEventListener('click', event);
}

rtAPI.displayElement = function (element, value, showValue) {
    if (!rtAPI.isValidElement(element)) return;
    //if (!showValue) showValue = 'inherit';
    if (value === true || value === false) value = (value === true) ? showValue : 'none';
    element.style.display = value;
}

//#endregion

//#region Validation

rtAPI.markInputRequired = function (element, requiredGroup, value) {
    if (!rtAPI.isValidElement(element)) return;
    if (requiredGroup == '' || requiredGroup == undefined) return;
    var errorMessage = eval(`rtAPI.security.errorMessage.${value}`);
    element.setAttribute('requiredGroup', requiredGroup);
    element.setAttribute('requiredErrorMessage', errorMessage);
    element.removeAttribute('required');
}

rtAPI.resetRequired = function () {
    const requiredInputs = document.querySelectorAll("input[requiredGroup]");
    requiredInputs.forEach(requiredInput => {
        requiredInput.removeAttribute('required');
    });
}

rtAPI.validateRequired = function (groupName) {
    var result = true;
    const requiredInputs = document.querySelectorAll(`input[requiredGroup='${groupName}']`);
    requiredInputs.forEach(requiredInput => {
        requiredInput.setAttribute('required', '');
        if (!requiredInput.validity.valueMissing) return;
        if (result) requiredInput.reportValidity(); //Focus and prompt first fail
        rtAPI.messages.addCritical(requiredInput.getAttribute('requirederrormessage'), true);
        result = false;
    });
    if (!result) rtAPI.messages.displayAddedMessages();
    return result;
}

//#endregion

